import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularFrameworkComponent } from './components/angular-framework/angular-framework.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@shared/shared.module';



@NgModule({
  declarations: [AngularFrameworkComponent],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild([
      {
        path: '',
        component: AngularFrameworkComponent,
        children: [
          {
            path: 'intro',
            data: {
              title: 'Ο κύκλος των μαθημάτων για Web Developers',
              description:
                'Ο κύκλος των μαθημάτων που θα ακολουθήσεις στο δρόμο του να γίνεις καταρτισμένος Web Developer και έτοιμος να βγείς στην αγορά εργασίας.',
              // robots : ''
            },
            loadChildren: () =>
              import(
                '../angular-framwork-intro/angular-framework-intro.module'
              ).then((m) => m.AngularFrameworkIntroModule),
          },
          {
            path: 'chapters',
            data: {
              title: 'Κεφάλαια προγραμματισμού του Mastering Angular Bootcamp',
              description:
                'Τα κεφάλαια των μαθημάτων του Mastering Angular Bootcamp',
              // robots : ''
            },
            loadChildren: () =>
              import('./../chapters/chapters.module').then(
                (m) => m.ChaptersModule
              ),
          },
          {
            path: 'basis',
            data: {
              title: 'Προγραμματιστικά Θεμέλια ενός Web Developer',
              description:
                'Οι βάσεις που θα στήσουμε σε αυτό τον κύκλο εχουν στόχο την εισαγωγή στον προγραμματισμό και την κατανόηση των τεχνολογιών κάθε web application',
              // robots : ''
            },
            loadChildren: () =>
              import('../basis/basis.module').then((m) => m.BasisModule),
          },
          {
            path: 'development',
            data: {
              title: 'Κατέκτησε το Web Development Enviroment',
              description:
                'Σε αυτό τον κύκλο θα κατανοήσεις τι χρειάζεται για την ανάπτυξη ενός web application.',
              // robots : ''
            },
            loadChildren: () =>
              import('../development/development.module').then(
                (m) => m.DevelopmentModule
              ),
          },
          {
            path: 'framework',
            data: {
              title: 'Εκπαιδεύσου στο Web Framework σου',
              description:
                'Σε αυτό τον κύκλο θα εκπαιδευτείς σε ένα από τα δύο πιο δημοφιλή JavaScript Frameworks : Angular,React',
              // robots : ''
            },
            loadChildren: () =>
              import('../framework/framework.module').then(
                (m) => m.FrameworkModule
              ),
          },
          {
            path: 'prerequisites',
            data: {
              title: 'Προαπαιτούμενες γνώσεις Web Developer',
              description:
                'Οι προαπαιτούμενες γνώσεις που θα χρειαστούν κατά τη διάρκει του Junior Front End developer bootcamp',
              // robots : ''
            },
            loadChildren: () =>
              import('../prerequisites/prerequisites.module').then(
                (m) => m.PrerequisitesModule
              ),
          },
          {
            path: 'information',
            data: {
              title: 'Πληροφορίες για το Σεμινάριο Web Development',
              description:
                'Οι σχετικές πληροφορίες του σεμιναρίου για Junior Web Developers',
              // robots : ''
            },
            loadChildren: () =>
              import('../information/information.module').then(
                (m) => m.InformationModule
              ),
          },
          {
            path: 'career',
            data: {
              title: 'Σταδιοδρομία στο Web Development',
              description:
                'Είμαστε δίπλα στους σπουδαστές και τους απόφοιτούς μας',
              // robots : ''
            },
            loadChildren: () =>
              import('../career/career.module').then(
                (m) => m.CareerModule
              ),
          },
          {
            path: 'project',
            data: {
              title: 'Πρακτική Εφαρμογή των Γνώσεων σε Project',
              description:
                'Οι σπουδαστές καλούνται να υλοποιήσουν τις τεχνικές τους γνώσεις στην πράξη.',
              // robots : ''
            },
            loadChildren: () =>
              import('../project/project.module').then(
                (m) => m.ProjectModule
              ),
          },
        ],
      },
    ]),
  ],
})
export class AngularFrameworkModule {}
